import styles from './TopNav.module.scss'
import cx from 'classnames'
import DropDownMonthFilter from '../DropDownFilter/DropDownMonthFilter'
import { IconNavigationGroupProps, IconNavType, MonthProps } from '~types'
import { isNextButtonDisabled, isPrevButtonDisabled } from '../../../../utils'
import { useEventsStore } from 'store/useEventsStore'
import IconNavigationGroup from 'components/modules/IconNavigationGroup/IconNavigationGroup'
import { useWindowSize } from 'utils/hooks'
import DropDownEventFilter from '../DropDownEventFilter/DropDownEventFilter'

interface TopNavProps {
  setSelectedMonth: (month: MonthProps) => void
  handleNavigation: (key: string, shouldScrollTop?: boolean) => void
  isTablet: boolean | null
  iconNavigationGroup?: IconNavigationGroupProps
  isLoading: boolean
}

const TopNav = ({ setSelectedMonth, handleNavigation, isTablet, iconNavigationGroup, isLoading }: TopNavProps) => {
  const { selectedMonth, activeMonthList } = useEventsStore()
  const monthList = activeMonthList.map(item => item.month) || []
  const currentMonthKey = selectedMonth?.shortLabel.replace(/\s+/g, '-')
  const { isBreakpoint: isBelowSm } = useWindowSize('sm', '<')

  const monthNavigationButtons: IconNavType[] = [
    {
      title: 'Previous month',
      iconName: 'chevron_left',
      onClick: () => handleNavigation('previous'),
      isDisabled: isPrevButtonDisabled(currentMonthKey, monthList) || isLoading,
      isActive: false
    },
    {
      title: 'Next month',
      iconName: 'chevron_right',
      onClick: () => handleNavigation('next'),
      isDisabled: isNextButtonDisabled(currentMonthKey, monthList) || isLoading,
      isActive: false
    }
  ]

  return (
    <div className={styles['navigation-filter-container']}>
      <div className={styles['left-navigation-group']}>
        <div className={styles['top-nav-inner']}>
          <div className={styles['dropdown-filter']}>
            <DropDownMonthFilter
              selectedMonth={selectedMonth}
              activeMonthList={monthList}
              handleMonthNavChange={setSelectedMonth}
              isLoading={isLoading}
            />
          </div>

          {!isTablet && (
            <div className={styles['month-navigation-group']}>
              <IconNavigationGroup
                icons={monthNavigationButtons}
                isLoading={isLoading}
                alignment='left'
                parentLinkModule='calendar'
                theme={{
                  hoverBackgroundColor: 'lightest'
                }}
                removePadding
              />
            </div>
          )}

          {iconNavigationGroup && isBelowSm && (
            <div className={styles['icon-group']}>
              <IconNavigationGroup
                {...iconNavigationGroup}
                removePadding
                parentLinkModule='calendar'
                isLoading={isLoading}
              />
            </div>
          )}
        </div>

        {!isTablet && <div className={cx([styles['divider'], isLoading && styles['divider--is-dark']])} />}
        <DropDownEventFilter isLoading={isLoading} />
      </div>
      {iconNavigationGroup && !isBelowSm && (
        <IconNavigationGroup {...iconNavigationGroup} removePadding parentLinkModule='calendar' isLoading={isLoading} />
      )}
    </div>
  )
}

export default TopNav
